export default "__VITE_ASSET__DoabQVtX__"